export default __webpack_public_path__ + "static/lvs-logo-7c2bdac2644f0f1c6523a12a1d772716.svg";